import React, { useEffect } from "react";
import "./c-load-spinner.scss";

interface LoadSpinnerProps {
  useOldStyle?: boolean;
}

export const LoadSpinner: React.FC<LoadSpinnerProps> = ({ useOldStyle }) => {
  useEffect(() => {
    document.body.classList.add("products-busy");
    return () => {
      document.body.classList.remove("products-busy");
    };
  }, []);

  return useOldStyle ? (
    <div className="c-loader-legacy">
      <div className="c-loader-legacy__spinner">
        <div className="c-loader-legacy__animation" />
      </div>
    </div>
  ) : (
    <div className="c-loader">
      <div className="c-loader__text">Loading</div>
      <div className="c-loader__doughnut" />
    </div>
  );
};
